// extracted by mini-css-extract-plugin
export default {"welcomeText":"AgreementDetail_welcomeText__yFe-8","tacText":"AgreementDetail_tacText__JLG04"};